/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Icon, Pressable } from '@components/atoms'
import ReactImageGallery, { ReactImageGalleryProps } from 'react-image-gallery'

interface PropsType extends ReactImageGalleryProps {}

export const Gallery = (props: PropsType) => {
	return (
		<View css={style}>
			<ReactImageGallery
				showBullets={false}
				showFullscreenButton={false}
				showPlayButton={false}
				items={props.items}
				renderLeftNav={onClick => {
					return (
						<Pressable onClick={onClick} className="galleryLeftNavButton">
							<Icon name="chevron-left" className="galleryLeftNavIcon" />
						</Pressable>
					)
				}}
				renderRightNav={onClick => {
					return (
						<Pressable onClick={onClick} className="galleryRightNavButton">
							<Icon name="chevron-right" className="galleryRightNavIcon" />
						</Pressable>
					)
				}}
			/>
		</View>
	)
}

const style = css({
	'.galleryLeftNavButton': {
		position: 'absolute',
		zIndex: 5,
		top: 0,
		bottom: 0,
		left: 0,
		margin: 'auto',

		'.galleryLeftNavIcon': {
			fontSize: '100px',
			color: 'white',
			opacity: 0.5,
		},
	},

	'.galleryRightNavButton': {
		position: 'absolute',
		zIndex: 5,
		top: 0,
		bottom: 0,
		right: 0,
		margin: 'auto',

		'.galleryRightNavIcon': {
			fontSize: '100px',
			color: 'white',
			opacity: 0.5,
		},
	},
})
